import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import { tabs } from "./Dashboards/monitoringDashboardConfirg";
import { StyledMainBox, StyledTabs } from "../../components/commonComponents/StyledComponents/styled";
import SideNav from "../../components/commonComponents/Sidebar/SideNav";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { findMinSelectableDate, loadStores } from "../../api_calls/campaigns";
import { useDispatch, useSelector } from "react-redux";
import { deleteItems } from "../../Store/actions";
import { setBatchLoadingStatus } from "../../api_calls/requestConfig";

// to load tab content
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Monitoring = () => {
  const userStateDetails = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [value, setValue] = React.useState(0);
  const tabsConfig = tabs();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  React.useEffect(() => {
    setBatchLoadingStatus(true);
    loadStores("receipt-monitoring").then(resp => {
      if (resp.success) {
        const storeNames = typeof userStateDetails.stores_list !== "undefined" ? userStateDetails.stores_list.map(store => store.name) : [];
        findMinSelectableDate(storeNames);
      }
      setBatchLoadingStatus(false);
    });
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);

  return (
    <StyledMainBox component="main">
      {typeof userStateDetails.stores_list !== "undefined" && (
        <>
          <Box
            sx={{
              display: "flex", // Make the Box a flex container
              borderBottom: 1,
              borderColor: "divider",
              position: "sticky",
              top: "0",
              zIndex: 999,
              backgroundColor: "#fff",
            }}
          >
            <Box component={"div"}>
              <StyledTabs value={value} onChange={handleChange} aria-label="brand analytics" textColor={"#F04B55"}>
                {tabsConfig.map((tabDetail) => {
                  return <Tab key={tabDetail.unique_key} icon={tabDetail.icon} label={tabDetail.label} {...a11yProps(0)} />;
                })}
              </StyledTabs>
            </Box>
            {/* ----------- filters section ------------ */}
            {
              window.screen.width > 1300 && (
                <Box
                  component={"div"}
                  sx={{
                    flex: 1,
                  }}
                >
                  {tabsConfig[value].filter_component}
                </Box>
              )
            }

          </Box>

          {/* ----------- filters section ------------ */}
          {
            window.screen.width < 1300 && (
              <Box
                sx={{
                  display: "flex", // Make the Box a flex container
                  // borderBottom: 1,
                  // borderColor: "divider",
                  position: "sticky",
                  flexWrap: "wrap",
                  top: 45,
                  zIndex: 999,
                  backgroundColor: "#fff",
                }}
              >
                <Box
                  component={"div"}
                  width={600}
                  sx={{
                    flex: 1,
                  }}
                >
                  {tabsConfig[value].filter_component}
                </Box>
              </Box>
            )
          }

          {/* ============== tab contents =========== */}
          {tabsConfig.map((tabDetail, index) => {
            return (
              <CustomTabPanel value={value} index={index}>
                {tabDetail.dashboard}
              </CustomTabPanel>
            );
          })}
        </>
      )}
    </StyledMainBox>
  );
};

export default AccessControl(Monitoring, ["infra_store_monitoring_can_view"], [], ["infrastructure_section", "monitoring_infra"]);
